import { Injectable } from '@angular/core';

import {
  AndroidSettings,
  IOSSettings,
  NativeSettings,
} from 'capacitor-native-settings';
import {
  LBSErrorHandler,
  LBSErrorHandlerResult,
} from '../error-handler/error-handler';
import { LoggingService } from '../logging/logic/logging.service';
import { BarcodeError } from './barcode-errors';

@Injectable({
  providedIn: 'root',
})
export class BarcodeServiceErrorHandler implements LBSErrorHandler {
  // Lifecycle
  constructor(private logger: LoggingService) {}

  public async handleError(error: Error | any): Promise<LBSErrorHandlerResult> {
    if (Object.values(BarcodeError).includes(error?.message as BarcodeError)) {
      return await this.getErrorHandlerResultForKey(
        error.message as BarcodeError
      );
    }
    if (Object.values(BarcodeError).includes(error?.code as BarcodeError)) {
      return await this.getErrorHandlerResultForKey(
        error.code as BarcodeError
      );
    }
    this.logger.error(
      this.constructor.name,
      'given error',
      error?.message,
      'is not of type BarcodeError'
    );
    return undefined;
  }

  // Private Functions
  public async getErrorHandlerResultForKey(
    error: BarcodeError
  ): Promise<LBSErrorHandlerResult> {
    console.log('JBError try getting Barcode Error for', error);
    switch (error) {
      case BarcodeError.CANCELLED:
      case BarcodeError.CANCELLED_ANDROID:
      case BarcodeError.CANCELLED_IOS:
        // Do nothing
        console.log('JBError Cancelled error');
        return {};
      case BarcodeError.CAMERA_PERMISSION_DENIED:
      case BarcodeError.CAMERA_PERMISSION_DENIED_ANDROID:
        console.log('JBError CAMERA_PERMISSION_DENIED error');
        return {
          alert: {
            title:
              'ERROR-HANDLERS.BARCODE-ERRORS.CAMERA_PERMISSION_DENIED.TITLE',
            subtitle:
              'ERROR-HANDLERS.BARCODE-ERRORS.CAMERA_PERMISSION_DENIED.SUBTITLE',
            message:
              'ERROR-HANDLERS.BARCODE-ERRORS.CAMERA_PERMISSION_DENIED.MESSAGE',
            confirm:
              'ERROR-HANDLERS.BARCODE-ERRORS.CAMERA_PERMISSION_DENIED.CONFIRM',
            confirmFunc: () => {
              this.openSettings();
            },
            cancel:
              'ERROR-HANDLERS.BARCODE-ERRORS.CAMERA_PERMISSION_DENIED.CANCEL',
            cancelFunc: () => {
              console.log(
                'Prealert cancel pressed, cannot redirect to settings'
              );
            },
            showExportLog: false,
          },
        };

      default:
        this.logger.error(
          this.constructor.name,
          'Not Handled BarcodeError found!',
          error
        );
        return undefined;
    }
  }

  private async openSettings() {
    NativeSettings.open({
      optionAndroid: AndroidSettings.ApplicationDetails,
      optionIOS: IOSSettings.App,
    });
  }
}
